import { render, staticRenderFns } from "./examRecord2024.vue?vue&type=template&id=1b1ee880&scoped=true&"
import script from "./examRecord2024.vue?vue&type=script&lang=js&"
export * from "./examRecord2024.vue?vue&type=script&lang=js&"
import style0 from "./examRecord2024.vue?vue&type=style&index=0&id=1b1ee880&lang=scss&scoped=true&"
import style1 from "./examRecord2024.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ee880",
  null
  
)

export default component.exports